module.exports = __webpack_public_path__ + "static/media/mulher_r2_c3.4c02a86b.jpg";